<template>
  <el-main>
    <tabs />
  </el-main>
</template>

<script>
/*analytics wrapper*/

// components
import Tabs from "./tabs/Tabs";

export default {
  name: "PageContent",
  components: {
    Tabs
  }
};
</script>
